/* Howard Datos Store v1 — first-party semantic telemetry, no replay or form text. */
(() => {
  'use strict';
  const params=new URLSearchParams(location.search);
  if(window.__howardStoreTracker || window.Shopify?.designMode || params.has('preview_theme_id') || params.has('howard_analytics_test'))return;
  if(!['clashivfx.com','www.clashivfx.com'].includes(location.hostname))return;
  const path=location.pathname;
  if(!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages)\/[a-z0-9_-]+\/?|cart\/?|)?$/.test(path))return;
  window.__howardStoreTracker=true;
  const endpoint='https://howardia.site/api/store/events', storageKey='howard_store_session_v1';
  const pageId=crypto.randomUUID(), queue=[], seen=new Set(), timers=new Map();
  let active=false, initialized=false, session=null, emitted=0, checkoutTime=0, sectionObserver=null;
  const token=(value,max=100)=>String(value??'').replace(/[^a-zA-Z0-9_.:/-]/g,'_').slice(0,max);
  const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  function identity(){
    const now=Date.now();
    try{
      const saved=JSON.parse(localStorage.getItem(storageKey)||'null');
      if(saved && typeof saved.id==='string' && /^[a-f0-9-]{36}$/.test(saved.id) && now-saved.at<1800000 && now>=saved.at)session=saved;
    }catch{/* storage can be unavailable */}
    if(!session || now-session.at>=1800000)session={id:crypto.randomUUID(),at:now};
    session.at=now;
    try{localStorage.setItem(storageKey,JSON.stringify(session));}catch{/* memory-only session */}
    return session.id;
  }
  function emit(event_name,locationName='',product='',detail=''){
    if(!active || !allowed() || document.visibilityState==='hidden' || emitted>=250)return;
    queue.push({event_id:crypto.randomUUID(),session_id:identity(),page_id:pageId,event_name,
      page_path:path,location:token(locationName,160),product_ref:token(product),detail:token(detail),
      device:matchMedia('(max-width: 767px)').matches?'mobile':'desktop'});
    emitted++;
    if(queue.length>=25)flush();
  }
  function flush(){
    if(!active || !allowed()){queue.length=0;return;}
    if(!queue.length)return;
    const payload=JSON.stringify({analytics_allowed:true,events:queue.splice(0,25)});
    // text/plain avoids a preflight for navigation-time sends. No cookies/keys.
    try{
      if(navigator.sendBeacon?.(endpoint,new Blob([payload],{type:'text/plain'})))return;
      fetch(endpoint,{method:'POST',body:payload,headers:{'Content-Type':'text/plain'},credentials:'omit',keepalive:true}).catch(()=>{});
    }catch{/* telemetry must never interrupt shopping */}
  }
  function place(element){
    const area=element?.closest?.('[data-store-location],.shopify-section,cart-drawer');
    if(area?.matches('cart-drawer'))return area.classList.contains('is-empty')?'drawer.empty':'drawer.with_product';
    return token(area?.dataset.storeLocation||area?.id?.split('__').pop()||'page',160);
  }
  function product(element){
    const card=element?.closest?.('[data-product-id],.card-wrapper,.software-title-card');
    const href=card?.querySelector('a[href*="/products/"]')?.getAttribute('href')||'';
    return token(card?.dataset.productId||href.match(/\/products\/([a-z0-9_-]+)/)?.[1]||'');
  }
  function checkout(where){
    if(Date.now()-checkoutTime<1000)return;
    checkoutTime=Date.now();emit('checkout_clicked',where);
  }
  function updateConsent(){
    active=allowed();
    if(!active){
      queue.length=0;session=null;
      timers.forEach(clearTimeout);timers.clear();
      try{localStorage.removeItem(storageKey);}catch{/* unavailable */}
      return;
    }
    if(!initialized){initialized=true;start();}
    else {pageView();refreshSections();}
  }
  function refreshSections(){
    if(sectionObserver && active && document.visibilityState==='visible')document.querySelectorAll('main h2,.shopify-section h2').forEach(element=>{
      sectionObserver.unobserve(element);sectionObserver.observe(element);
    });
  }
  function pageView(){
    if(seen.has('page'))return;
    seen.add('page');emit('page_viewed');
    const handle=path.match(/\/products\/([a-z0-9_-]+)/)?.[1];
    if(handle)emit('product_viewed','product_page',handle);
  }
  function start(){
    pageView();
    document.addEventListener('click',event=>{
      if(!active || !(event.target instanceof Element))return;
      const control=event.target.closest('a,button,summary');
      if(!control || control.closest('#shopify-pc__banner,#shopify-pc__prefs,[data-customer-form]'))return;
      const href=control.getAttribute('href')||'',where=place(control);
      if(control.matches('[name="checkout"],#CartDrawer-Checkout') || /^\/(?:[a-z-]+\/)?checkout(?:\/|\?|$)/.test(href)){
        checkout(where);return;
      }
      // Stable control IDs or product handle; never labels, inputs, full URLs.
      const action=control.id||control.getAttribute('name')||(/^#/.test(href)?href.slice(1):control.tagName.toLowerCase());
      emit('ui_clicked',where,product(control),action);
    },{passive:true});
    document.addEventListener('submit',event=>{
      if(event.submitter?.name==='checkout')checkout(place(event.target));
    },{passive:true});
    document.addEventListener('cart:item-added',event=>emit('product_added_to_cart',token(event.detail?.source||'product_form'),event.detail?.variantId));
    document.addEventListener('atc-upsell:shown',()=>emit('offer_shown','add_to_cart_popup'));
    document.addEventListener('atc-upsell:accepted',event=>{
      emit('offer_added','add_to_cart_popup',event.detail?.variantId);
      emit('product_added_to_cart','add_to_cart_popup',event.detail?.variantId);
    });
    document.addEventListener('atc-upsell:declined',()=>emit('offer_dismissed','add_to_cart_popup'));
    const drawer=document.querySelector('cart-drawer');
    if(drawer){
      let wasOpen=drawer.classList.contains('active');
      new MutationObserver(()=>{
        const open=drawer.classList.contains('active');
        if(open && !wasOpen)emit('cart_drawer_opened',place(drawer));
        wasOpen=open;
      }).observe(drawer,{attributes:true,attributeFilter:['class']});
    }
    let scheduled=false;
    function depth(){
      scheduled=false;
      const height=document.documentElement.scrollHeight-innerHeight;
      if(height<100)return;
      const percent=100*scrollY/height;
      [25,50,75,90].forEach(mark=>{
        const key='scroll'+mark;
        if(percent>=mark && !seen.has(key) && active && allowed() && document.visibilityState==='visible'){
          seen.add(key);emit('scroll_depth','page','',String(mark));
        }
      });
    }
    window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(depth);}},{passive:true});
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        const element=entry.target,key='section:'+place(element)+':'+token(element.id||element.getAttribute('data-i18n')||'heading');
        if(entry.intersectionRatio>=.5 && document.visibilityState==='visible' && active && allowed() && !seen.has(key)){
          if(!timers.has(element))timers.set(element,setTimeout(()=>{
            timers.delete(element);
            if(active && allowed() && document.visibilityState==='visible'){
              seen.add(key);emit('section_exposed',key.slice(8));
            }
          },1000));
        }else if(timers.has(element)){clearTimeout(timers.get(element));timers.delete(element);}
      }),{threshold:[0,.5]});
      // Observe headings, not half of an entire oversized section.
      sectionObserver=observer;refreshSections();
    }
    document.addEventListener('play',event=>{
      const video=event.target;
      if(!(video instanceof HTMLVideoElement))return;
      emit('demo_started',place(video),product(video),video.autoplay?'autoplay':'playback');
    },true);
    document.addEventListener('error',event=>{
      if(event.target instanceof HTMLVideoElement)emit('demo_error',place(event.target),product(event.target),'media_error');
    },true);
    document.addEventListener('timeupdate',event=>{
      const video=event.target;
      if(!(video instanceof HTMLVideoElement) || !Number.isFinite(video.duration) || video.duration<=0)return;
      [25,50,75,100].forEach(mark=>{
        const key='demo:'+place(video)+':'+product(video)+':'+mark;
        if(100*video.currentTime/video.duration>=mark-.5 && !seen.has(key)){
          seen.add(key);emit('demo_progress',place(video),product(video),`${video.autoplay?'autoplay':'playback'}.${mark}`);
        }
      });
    },true);
  }
  document.addEventListener('visitorConsentCollected',updateConsent);
  document.addEventListener('visibilitychange',()=>{
    if(document.visibilityState==='hidden'){timers.forEach(clearTimeout);timers.clear();flush();}
    else refreshSections();
  });
  window.addEventListener('pagehide',flush);
  setInterval(()=>{if(active && !allowed())updateConsent();else flush();},8000);
  const ready=()=>{
    if(window.Shopify?.customerPrivacy)updateConsent();
    else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)updateConsent();});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
